export const UPDATE = 1;
export const SAVE = 2;
export const ORIGEN_ACREDITADO = 5;
export const A_VERIFICAR = 1;
export const VERIFICADO = 2;
export const RECHAZADO = 3;
export const TIPO_ARCHIVO_FOTO = 1;
export const TIPO_ARCHIVO_FIRMA = 2;
export const TIPO_ARCHIVO_OTROS = 3;
export const TAG_TIPO_EMPRESA = 1;
export const TAG_TIPO_PRODUCTO = 2;
